import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import busquedaTypes from "../actions/busquedas.actions";
import { storeResults, storeVariables, errorResult } from "../actions/busquedas.actions";
import api from "../api/api";

export function* getDinardapByIdentificacion() {
  yield takeEvery(
    busquedaTypes.GET_DINARDAP_IDENTIFICACION,
    takeLatestDinardapByIdentificacion
  );
}

function* takeLatestDinardapByIdentificacion({ payload }) {
    const response = yield call(api.post, `/v1/busquedas/persona/identificacion`, payload);

    if (response.status === 200) {
        yield put(storeResults(response.data.result));
    } else {
        yield put(errorResult());
    }
}

export function* getDinardapByNombresApellidos() {
  yield takeEvery(
    busquedaTypes.GET_DINARDAP_APELLIDOS_NOMBRES,
    takeLatestDinardapByNombresApellidos
  );
}

function* takeLatestDinardapByNombresApellidos({ payload }) {
  const response = yield call(
    api.post,
    `/v1/busquedas/persona/nombresapellidos`,
    payload
  );

  if (response.status === 200) {
    yield put(storeResults(response.data.result));
  } else {
    yield put(errorResult());
  }
}

export function* getDinardapByPlacaMotorChasis() {
  yield takeEvery(
    busquedaTypes.GET_DINARDAP_PLACA_MOTOR_CHASIS,
    takeLatestDinardapByPlacaMotorChasis
  );
}

function* takeLatestDinardapByPlacaMotorChasis({ payload }) {
  const response = yield call(api.post, `/v1/busquedas/vehiculo`, payload);
  if (response.status === 200) {
    yield put(storeResults(response.data.result));
  } else {
    yield put(errorResult());
  }
}

export function* getDinardapByRuc() {
  yield takeEvery(busquedaTypes.GET_DINARDAP_RUC, takeLatestDinardapByRuc);
}

function* takeLatestDinardapByRuc({ payload }) {
  const response = yield call(api.post, `/v1/busquedas/empresa/ruc`, payload);
  if (response.status === 200) {
    yield put(storeResults(response.data.result));
  }
}

export function* getDinardapByRazonSocial() {
  yield takeEvery(
    busquedaTypes.GET_DINARDAP_RAZON_SOCIAL,
    takeLatestDinardapByRazonSocial
  );
}

function* takeLatestDinardapByRazonSocial({ payload }) {
  const response = yield call(
    api.post,
    `/v1/busquedas/empresa/razonSocial`,
    payload
  );
  if (response.status === 200) {
    yield put(storeResults(response.data.result));
  }
}

export function* getDinardapByIdentificacionNacionalidad() {
  yield takeEvery(
    busquedaTypes.GET_DINARDAP_IDENTIFICACION_NACIONALIDAD,
    takeLatestDinardapByIdentificacionNacionalidad
  );
}

function* takeLatestDinardapByIdentificacionNacionalidad({ payload }) {
  const response = yield call(
    api.post,
    `/v1/busquedas/persona/identificacionNacionalidad`,
    payload
  );
  if (response.status === 200) {
    yield put(storeResults(response.data.result));
  }
}

export function* getDinardapByIdentificacionAnio() {
  yield takeEvery(
    busquedaTypes.GET_DINARDAP_IDENTIFICACION_ANIO,
    takeLatestDinardapByIdentificacionAnio
  );
}

function* takeLatestDinardapByIdentificacionAnio({ payload }) {
  const response = yield call(
    api.post,
    `/v1/busquedas/persona/identificacionAnio`,
    payload
  );
  if (response.status === 200) {
    yield put(storeResults(response.data.result));
  }
}

export function* getDinardapByDocImportadorNumAutorizacion() {
  yield takeEvery(
    busquedaTypes.GET_DINARDAP_DOCIMPORTADOR_NUMAUTORIZACION,
    takeLatestDinardapByDocImportadorNumAutorizacion
  );
}

function* takeLatestDinardapByDocImportadorNumAutorizacion({ payload }) {
  const response = yield call(
    api.post,
    `/v1/busquedas/persona/docImportador/numAutorizacion`,
    payload
  );
  if (response.status === 200) {
    yield put(storeResults(response.data.result));
  }
}

export function* getAllVariables() {
  yield takeLatest(busquedaTypes.GET_ALL_VARIABLES, takeLatestAllVariables);
}

function* takeLatestAllVariables() {
  const response = yield call(api.get, `/v1/busquedas/variables/all`);
  yield put(storeVariables(response.data.result));
}
